import type { VipLevelType } from '@/types';
export const vipLevels: VipLevelType[] = [{
  id: 1,
  rankUrl: '/assets/vip-club/ranks/bronze.svg',
  title: 'bronze',
  textColor: '#F7C590',
  bgColor: '#CB835580',
  exp: 10000,
  privileges: {
    level: 'bronze',
    rakeback: '5%',
    rankUpBonus: true,
    dailyBonus: true,
    weeklyBonus: true,
    monthlyBonus: true,
    reloadBonus: false,
    vipHost: false,
    sponsoredBattles: false,
    customizedBenefits: false
  }
}, {
  id: 2,
  rankUrl: '/assets/vip-club/ranks/silver.svg',
  title: 'silver',
  textColor: '#FDFDFD',
  bgColor: '#D0D0D080',
  exp: 20000,
  privileges: {
    level: 'silver',
    rakeback: '10%',
    rankUpBonus: true,
    dailyBonus: true,
    weeklyBonus: true,
    monthlyBonus: true,
    reloadBonus: false,
    vipHost: false,
    sponsoredBattles: false,
    customizedBenefits: false
  }
}, {
  id: 3,
  rankUrl: '/assets/vip-club/ranks/gold.svg',
  title: 'gold',
  textColor: '#FEFCC2',
  bgColor: '#D7A84580',
  exp: 30000,
  privileges: {
    level: 'gold',
    rakeback: '15%',
    rankUpBonus: true,
    dailyBonus: true,
    weeklyBonus: true,
    monthlyBonus: true,
    reloadBonus: false,
    vipHost: false,
    sponsoredBattles: false,
    customizedBenefits: false
  }
}, {
  id: 4,
  rankUrl: '/assets/vip-club/ranks/platinum.svg',
  title: 'platinum',
  textColor: '#FFFFFF',
  bgColor: '#B9C7CF80',
  exp: 40000,
  privileges: {
    level: 'platinum',
    rakeback: '20%',
    rankUpBonus: true,
    dailyBonus: true,
    weeklyBonus: true,
    monthlyBonus: true,
    reloadBonus: false,
    vipHost: false,
    sponsoredBattles: false,
    customizedBenefits: false
  }
}, {
  id: 5,
  rankUrl: '/assets/vip-club/ranks/palladium.svg',
  title: 'palladium',
  textColor: '#E5E5E3',
  bgColor: '#A4A4AC80',
  exp: 50000,
  privileges: {
    level: 'bronze',
    rakeback: '5%',
    rankUpBonus: true,
    dailyBonus: true,
    weeklyBonus: true,
    monthlyBonus: true,
    reloadBonus: false,
    vipHost: false,
    sponsoredBattles: false,
    customizedBenefits: false
  }
}, {
  id: 6,
  rankUrl: '/assets/vip-club/ranks/rhodium.svg',
  title: 'rhodium',
  textColor: '#FEECF1',
  bgColor: '#B993A180',
  exp: 60000,
  privileges: {
    level: 'bronze',
    rakeback: '5%',
    rankUpBonus: true,
    dailyBonus: true,
    weeklyBonus: true,
    monthlyBonus: true,
    reloadBonus: false,
    vipHost: false,
    sponsoredBattles: false,
    customizedBenefits: false
  }
}, {
  id: 7,
  rankUrl: '/assets/vip-club/ranks/sapphire.svg',
  title: 'sapphire',
  textColor: '#DCF9FF',
  bgColor: '#1656D680',
  exp: 70000,
  privileges: {
    level: 'bronze',
    rakeback: '5%',
    rankUpBonus: true,
    dailyBonus: true,
    weeklyBonus: true,
    monthlyBonus: true,
    reloadBonus: false,
    vipHost: false,
    sponsoredBattles: false,
    customizedBenefits: false
  }
}, {
  id: 8,
  rankUrl: '/assets/vip-club/ranks/emerald.svg',
  title: 'emerald',
  textColor: '#15FEE0',
  bgColor: '#2E826380',
  exp: 80000,
  privileges: {
    level: 'bronze',
    rakeback: '5%',
    rankUpBonus: true,
    dailyBonus: true,
    weeklyBonus: true,
    monthlyBonus: true,
    reloadBonus: false,
    vipHost: false,
    sponsoredBattles: false,
    customizedBenefits: false
  }
}, {
  id: 9,
  rankUrl: '/assets/vip-club/ranks/ruby.svg',
  title: 'ruby',
  textColor: '#FF9DB1',
  bgColor: '#C1103780',
  exp: 90000,
  privileges: {
    level: 'bronze',
    rakeback: '5%',
    rankUpBonus: true,
    dailyBonus: true,
    weeklyBonus: true,
    monthlyBonus: true,
    reloadBonus: false,
    vipHost: false,
    sponsoredBattles: false,
    customizedBenefits: false
  }
}, {
  id: 10,
  rankUrl: '/assets/vip-club/ranks/diamond.svg',
  title: 'diamond',
  textColor: '#FFFFFF',
  bgColor: '#C7D7E880',
  exp: 100000,
  privileges: {
    level: 'bronze',
    rakeback: '5%',
    rankUpBonus: true,
    dailyBonus: true,
    weeklyBonus: true,
    monthlyBonus: true,
    reloadBonus: false,
    vipHost: false,
    sponsoredBattles: false,
    customizedBenefits: false
  }
}, {
  id: 11,
  rankUrl: '/assets/vip-club/ranks/blue-diamond.svg',
  title: 'blue diamond',
  textColor: '#E9FFFF',
  bgColor: '#91F8FD80',
  exp: 110000,
  privileges: {
    level: 'bronze',
    rakeback: '5%',
    rankUpBonus: true,
    dailyBonus: true,
    weeklyBonus: true,
    monthlyBonus: true,
    reloadBonus: false,
    vipHost: false,
    sponsoredBattles: false,
    customizedBenefits: false
  }
}, {
  id: 12,
  rankUrl: '/assets/vip-club/ranks/red-diamond.svg',
  title: 'red diamond',
  textColor: '#FFCBD6',
  bgColor: '#E1376280',
  exp: 120000,
  privileges: {
    level: 'bronze',
    rakeback: '5%',
    rankUpBonus: true,
    dailyBonus: true,
    weeklyBonus: true,
    monthlyBonus: true,
    reloadBonus: false,
    vipHost: false,
    sponsoredBattles: false,
    customizedBenefits: false
  }
}, {
  id: 13,
  rankUrl: '/assets/vip-club/ranks/pink-star.svg',
  title: 'pink star',
  textColor: '#FFEBF6',
  bgColor: '#FE83C580',
  exp: 130000,
  privileges: {
    level: 'bronze',
    rakeback: '5%',
    rankUpBonus: true,
    dailyBonus: true,
    weeklyBonus: true,
    monthlyBonus: true,
    reloadBonus: false,
    vipHost: false,
    sponsoredBattles: false,
    customizedBenefits: false
  }
}, {
  id: 14,
  rankUrl: '/assets/vip-club/ranks/black-opal.svg',
  title: 'black opal',
  textColor: '#DADADA',
  bgColor: '#6C6C6C80',
  exp: 140000,
  privileges: {
    level: 'bronze',
    rakeback: '5%',
    rankUpBonus: true,
    dailyBonus: true,
    weeklyBonus: true,
    monthlyBonus: true,
    reloadBonus: false,
    vipHost: false,
    sponsoredBattles: false,
    customizedBenefits: false
  }
}, {
  id: 15,
  rankUrl: '/assets/vip-club/ranks/crown-jewel.svg',
  title: 'crown jewel',
  textColor: '#FCFFE6',
  bgColor: '#E7FF5880',
  exp: 150000,
  privileges: {
    level: 'bronze',
    rakeback: '5%',
    rankUpBonus: true,
    dailyBonus: true,
    weeklyBonus: true,
    monthlyBonus: true,
    reloadBonus: false,
    vipHost: false,
    sponsoredBattles: false,
    customizedBenefits: false
  }
}];